<template>
  <div class="aInspectionPlanDetail-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('aInspectionPlanDetail.page.title')"
      :subtitle="$t('aInspectionPlanDetail.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-back" @click="goBack">
          {{ $t('common.back') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- 计划信息面板 -->
    <div class="ds-panel ds-panel--detail" v-loading="loading">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('aInspectionPlanDetail.title') }}</span>
      </div>
      <div class="ds-panel__body">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('aInspectionPlanDetail.planName') }}</div>
              <div class="ds-field__value">{{ aInspectionPlanDetailInfo.inspectionPlanName || '-' }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('aInspectionPlanDetail.planRoute') }}</div>
              <div class="ds-field__value">{{ aInspectionPlanDetailInfo.inspectionRouteName || '-' }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('aInspectionPlanDetail.planPeriod') }}</div>
              <div class="ds-field__value">{{ aInspectionPlanDetailInfo.inspectionPlanPeriodName || '-' }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('aInspectionPlanDetail.signType') }}</div>
              <div class="ds-field__value">{{ aInspectionPlanDetailInfo.signTypeName || '-' }}</div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('aInspectionPlanDetail.dateRange') }}</div>
              <div class="ds-field__value ds-num">
                {{ aInspectionPlanDetailInfo.startDate || '-' }} ~ {{ aInspectionPlanDetailInfo.endDate || '-' }}
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('aInspectionPlanDetail.timeRange') }}</div>
              <div class="ds-field__value ds-num">
                {{ aInspectionPlanDetailInfo.startTime || '-' }} ~ {{ aInspectionPlanDetailInfo.endTime || '-' }}
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('aInspectionPlanDetail.taskAdvance') }}</div>
              <div class="ds-field__value ds-num">{{ aInspectionPlanDetailInfo.beforeTime || '-' }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('aInspectionPlanDetail.creator') }}</div>
              <div class="ds-field__value">{{ aInspectionPlanDetailInfo.createUserName || '-' }}</div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('aInspectionPlanDetail.createTime') }}</div>
              <div class="ds-field__value ds-num">{{ formatDateTimeSec(aInspectionPlanDetailInfo.createTime) }}</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <div class="ds-field">
              <div class="ds-field__label">{{ $t('aInspectionPlanDetail.status') }}</div>
              <div class="ds-field__value">
                <ds-status-tag :type="resolveState" :label="aInspectionPlanDetailInfo.stateName || '-'" />
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <!-- 标签页面板 -->
    <div class="ds-panel ds-panel--tabs">
      <el-tabs v-model="aInspectionPlanDetailInfo._currentTab"
        @tab-click="changeTab(aInspectionPlanDetailInfo._currentTab)">
        <el-tab-pane :label="$t('aInspectionPlanDetail.staff')" name="aInspectionPlanDetailStaff">
          <a-inspection-plan-detail-staff ref="aInspectionPlanDetailStaff" />
        </el-tab-pane>
        <el-tab-pane :label="$t('aInspectionPlanDetail.route')" name="adminPointRoute">
          <admin-point-route ref="adminPointRoute" />
        </el-tab-pane>
        <el-tab-pane :label="$t('aInspectionPlanDetail.point')" name="aInspectionRoutePoint">
          <a-inspection-route-point ref="aInspectionRoutePoint" />
        </el-tab-pane>
        <el-tab-pane :label="$t('aInspectionPlanDetail.task')" name="adminRouteTask">
          <admin-route-task ref="adminRouteTask" />
        </el-tab-pane>
        <el-tab-pane :label="$t('aInspectionPlanDetail.detail')" name="adminPointTaskDetail">
          <admin-point-task-detail ref="adminPointTaskDetail" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getInspectionPlanDetail } from '@/api/inspection/aInspectionPlanDetailApi'
import AInspectionPlanDetailStaff from '@/components/inspection/AInspectionPlanDetailStaff'
import AdminPointRoute from '@/components/inspection/AdminPointRoute'
import AInspectionRoutePoint from '@/components/inspection/AInspectionRoutePoint'
import AdminRouteTask from '@/components/inspection/AdminRouteTask'
import AdminPointTaskDetail from '@/components/inspection/AdminPointTaskDetail'
import { formatDateTimeSec } from '@/utils/format'
import { resolveStatus } from '@/utils/statusMap'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'AInspectionPlanDetailList',
  components: {
    AInspectionPlanDetailStaff,
    AdminPointRoute,
    AInspectionRoutePoint,
    AdminRouteTask,
    AdminPointTaskDetail,
    DsPageHeader,
    DsStatusTag
  },
  data() {
    return {
      loading: false,
      aInspectionPlanDetailInfo: {
        beforeTime: '',
        createTime: '',
        createUserId: '',
        createUserName: '',
        endDate: '',
        endTime: '',
        inspectionPlanId: '',
        inspectionPlanName: '',
        inspectionPlanPeriod: '',
        inspectionPlanPeriodName: '',
        inspectionRouteId: '',
        inspectionRouteName: '',
        signType: '',
        signTypeName: '',
        startDate: '',
        startTime: '',
        state: '',
        stateName: '',
        _currentTab: 'aInspectionPlanDetailStaff'
      }
    }
  },
  computed: {
    /**
     * 巡检计划状态语义标签（inspection_plan 域）
     */
    resolveState() {
      const resolved = resolveStatus(this.aInspectionPlanDetailInfo.state, {
        domain: 'inspectionPlan',
        text: this.aInspectionPlanDetailInfo.stateName || '',
        fallbackLabel: this.aInspectionPlanDetailInfo.stateName || ''
      })
      return resolved.type
    }
  },
  created() {
    this.aInspectionPlanDetailInfo.inspectionPlanId = this.$route.query.inspectionPlanId
    this.getInspectionPlanDetail()
  },
  methods: {
    async getInspectionPlanDetail() {
      try {
        this.loading = true
        const params = {
          inspectionPlanId: this.aInspectionPlanDetailInfo.inspectionPlanId,
          page: 1,
          row: 1
        }
        const { data } = await getInspectionPlanDetail(params)
        if (data && data.length > 0) {
          Object.assign(this.aInspectionPlanDetailInfo, data[0])
          this.changeTab(this.aInspectionPlanDetailInfo._currentTab)
        }
      } catch (error) {
        console.error('获取巡检计划详情失败:', error)
        this.$message.error(this.$t('common.fetchError'))
      } finally {
        this.loading = false
      }
    },
    changeTab(tab) {
      this.aInspectionPlanDetailInfo._currentTab = tab
      setTimeout(() => {
        if (this.$refs[tab]) {
          this.$refs[tab].loadData({
            inspectionPlanId: this.aInspectionPlanDetailInfo.inspectionPlanId,
            inspectionRouteId: this.aInspectionPlanDetailInfo.inspectionRouteId
          })
        }
      }, 500)
    },
    formatDateTimeSec(value) {
      return formatDateTimeSec(value)
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push({ path: '/pages/property/inspectionPlan' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.aInspectionPlanDetail-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-md);

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--ds-spacing-sm);
    padding: var(--ds-spacing-sm) var(--ds-spacing-lg);
    background: var(--ds-gray-100);
    border-bottom: 1px solid var(--ds-gray-200);
  }

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }

  &__body {
    padding: var(--ds-spacing-lg);
  }
}

/* 详情字段 */
.ds-field {
  margin-bottom: var(--ds-spacing-md);

  &__label {
    font-size: var(--ds-font-size-xs);
    color: var(--ds-gray-500);
    margin-bottom: var(--ds-spacing-xs);
  }

  &__value {
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-800);
    line-height: 1.6;
    word-break: break-all;
  }
}
</style>
